var relativePath = '/chat';
export var createChatAutoAssignSettings = function (baseUrl, http) {
    var apiUrl = baseUrl + relativePath;
    var enableApiUrl = apiUrl + '/enable';
    var disableApiUrl = apiUrl + '/disable';
    return {
        getChatAutoAssignSettings: function () {
            return http.get(apiUrl);
        },
        setChatAutoAssignSettings: function (dto) {
            return http.put(apiUrl, dto);
        },
        enableChatAutoAssign: function () {
            return http.post(enableApiUrl, {});
        },
        disableChatAutoAssign: function () {
            return http.post(disableApiUrl, {});
        }
    };
};
//# sourceMappingURL=index.js.map